import icomoonEot from '../../../fonts/icomoon.eot'
import icomoonWoff from '../../../fonts/icomoon.woff'
import icomoonTtf from '../../../fonts/icomoon.ttf'
import icomoonSvg from '../../../fonts/icomoon.svg'

const FONTFACE = `
  @font-face {
    font-family: 'Nexia-IcoFont';
    src:url('${icomoonEot}?-uc1cze');
    src:url('${icomoonEot}?#iefix-uc1cze') format('embedded-opentype'),
      url('${icomoonWoff}?-uc1cze') format('woff'),
      url('${icomoonTtf}?-uc1cze') format('truetype'),
      url('${icomoonSvg}?-uc1cze#icomoon') format('svg');
    font-weight: normal;
    font-style: normal;
  }
`

export const loadFonts = () => {
  const head = document.getElementsByTagName('head')[0]
  const style = document.createElement('style')
  style.innerHTML = FONTFACE
  head.appendChild(style)
}
